import { Injectable } from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class InterfaceConfigService {
  
  interfaceconfig: any;

  private apiListUrl = webapi + 'interface_integration/api-list';

  constructor(private http: Http) { }


  getInterfaceApiList(): Promise<any[]> {
    return this.http.get(this.apiListUrl)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    console.error('[InterfaceConfigService] API error:', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/interface-config/interface-config.service.ts